import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ProjectSettingsServicedeskProactiveSupportAppExtraProps } from './projectSettingsServicedeskProactiveSupport.entrypoint.types.tsx';

type ProjectSettingsServicedeskProactiveSupportAppEntryPointProps = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	{},
	ProjectSettingsServicedeskProactiveSupportAppExtraProps
>;

export const projectSettingsServicedeskProactiveSupportAppEntryPoint: EntryPoint<
	ProjectSettingsServicedeskProactiveSupportAppEntryPointProps,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<ProjectSettingsServicedeskProactiveSupportAppEntryPointProps>(
		/* webpackChunkName: "async-project-settings-proactive-support", jiraSpaEntry: "async-project-settings-proactive-support" */
		'./ProjectSettingsServicedeskProactiveSupportApp.tsx',
	),
	getPreloadProps: ({ context: { match } }: EntryPointRouteParams) => {
		return {
			extraProps: {
				projectKey: String(match.params.projectKey ?? ''),
			},
		};
	},
});
